var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { Row } from "react-bootstrap";
import connect from "@irati/store/connect";
import linkedCardService from "@irati/perksgo/services/linkedcards";
import authentication from "@irati/auth";
import { hangPromise } from "@irati/utils/promise";
import Loading from "@irati/ui/src/Loading";
import id from "@irati/utils/id";
import { FormattedMessage } from "@irati/utils/lang";
import { DESKTOP, TABLET, PHONE_LANDSCAPE } from "@irati/ui/src/global/media";
import Slider from "@irati/ui/src/Slider";
import padlockIcon from "@irati/ui/images/padlock-icon.svg";
import ModalLocation from "@irati-tracking/perksgo/enums/ModalLocation";
import perksGOTracking from "@irati-tracking/perksgo/perksGO";
import FindOutMorePopup from "@irati-web/perksgo/src/components/Popup/FindOutMore";
import LANE_TYPES from "@irati/deals/constants/laneTypes";
import DEAL_MODES from "../../constants/dealMode";
import DEAL_PAGES from "../../constants/dealPage";
import DefaultSectionHeader from "../SectionHeader";
import Deal from "../Deal";
import DealContainer from "./styled/DealContainer";
import DealOverlay, { BodyWithShadow } from "./styled/DealOverlay";
export var ITEM_SIZE_REGULAR = "ITEM_SIZE_REGULAR";
export var ITEM_SIZE_SMALL = "ITEM_SIZE_SMALL";
var CLASS_NAME = "feed-slider";
var SETTINGS_REGULAR = {
    centerPadding: "30px",
    responsive: [
        { breakpoint: TABLET, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: DESKTOP, settings: { slidesToShow: 2, slidesToScroll: 2 } }
    ]
};
var SETTINGS_SMALL = {
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        { breakpoint: PHONE_LANDSCAPE, settings: { slidesToShow: 1.5, slidesToScroll: 1.5 } },
        { breakpoint: TABLET, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: DESKTOP, settings: { slidesToShow: 3, slidesToScroll: 3 } }
    ]
};
var FeedSliderGraph = /** @class */ (function (_super) {
    __extends(FeedSliderGraph, _super);
    function FeedSliderGraph() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasLinkedCards: undefined,
            load: hangPromise()
        };
        _this.componentDidMount = function () {
            _this.setState({ load: _this.hasLinkedCards() });
        };
        _this.hasLinkedCards = function () {
            var userId = authentication.user().uuid;
            return linkedCardService.getPerksGOCards({ userId: userId }).then(function (linkedCards) {
                _this.setState({ hasLinkedCards: linkedCards.length > 0 });
            });
        };
        _this.findOutMorePopup = React.createRef();
        return _this;
    }
    Object.defineProperty(FeedSliderGraph.prototype, "id", {
        get: function () {
            var className = this.props.className;
            return id(className, this.props);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedSliderGraph.prototype, "isLocked", {
        get: function () {
            var tag = this.props.tag;
            var hasLinkedCards = this.state.hasLinkedCards;
            return tag && tag.name.includes(LANE_TYPES.EARN.toLowerCase()) && !hasLinkedCards;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedSliderGraph.prototype, "settings", {
        get: function () {
            var _a = this.props, data = _a.data, isMobile = _a.isMobile, itemSize = _a.itemSize;
            var moreThanOne = data.length > 1;
            return __assign(__assign(__assign({}, SETTINGS_REGULAR), (itemSize === ITEM_SIZE_SMALL ? SETTINGS_SMALL : {})), { centerMode: moreThanOne && isMobile, infinite: moreThanOne && isMobile, draggable: moreThanOne && isMobile });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedSliderGraph.prototype, "mode", {
        get: function () {
            var itemSize = this.props.itemSize;
            return itemSize === ITEM_SIZE_SMALL ? DEAL_MODES.COMPACT : DEAL_MODES.DEFAULT;
        },
        enumerable: false,
        configurable: true
    });
    FeedSliderGraph.prototype.showModal = function () {
        perksGOTracking.showFindOutMoreModal(this.findOutMorePopup.current.props.modalLocation);
        this.findOutMorePopup.current.show();
    };
    FeedSliderGraph.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, tag = _a.tag, className = _a.className, logo = _a.logo, isFavouriteDeal = _a.isFavouriteDeal, userLocation = _a.userLocation, showDealLocation = _a.showDealLocation, capitaliseHeader = _a.capitaliseHeader, SectionHeader = _a.SectionHeader, sectionHeaderText = _a.sectionHeaderText, sectionBodyText = _a.sectionBodyText, keyExtractor = _a.keyExtractor, showSectionHeader = _a.showSectionHeader;
        var load = this.state.load;
        return (React.createElement("div", { id: this.id },
            showSectionHeader && (React.createElement(SectionHeader, { id: this.id, tag: tag, logo: logo, userLocation: userLocation, capitalise: capitaliseHeader, headerText: sectionHeaderText, bodyText: sectionBodyText })),
            React.createElement(Row, null,
                React.createElement(Loading, { load: load },
                    React.createElement(Slider, { id: this.id, className: className, settings: this.settings }, data.map(function (item, key) { return (React.createElement(DealContainer, { key: keyExtractor(item) },
                        _this.isLocked && (React.createElement(DealOverlay, { onClick: function () { return _this.showModal(); } },
                            React.createElement("img", { src: padlockIcon, alt: "padlock" }),
                            React.createElement(BodyWithShadow, { color: "white", weight: "bold", textAlign: "center" },
                                React.createElement(FormattedMessage, { id: "perks.locked.overlay.message" })))),
                        React.createElement(Deal, { isFavouriteDeal: isFavouriteDeal, showLocation: showDealLocation, id: id(keyExtractor(item, key), _this.id), deal: item, page: DEAL_PAGES.HOME, mode: _this.mode, trackingData: {
                                position: key + 1,
                                sectionHeader: sectionHeaderText,
                                userLocation: userLocation
                            } }))); })))),
            React.createElement(FindOutMorePopup, { modalLocation: ModalLocation.Homepage, ref: this.findOutMorePopup })));
    };
    FeedSliderGraph.defaultProps = {
        data: [],
        className: CLASS_NAME,
        itemSize: ITEM_SIZE_REGULAR,
        isMobile: false,
        capitaliseHeader: false,
        SectionHeader: DefaultSectionHeader,
        keyExtractor: function (item) { return item.uuid; },
        showSectionHeader: true
    };
    return FeedSliderGraph;
}(Component));
var mapStateToProps = function (state) { return ({
    isMobile: state.mq.lessThan.medium
}); };
export default connect(mapStateToProps)(FeedSliderGraph);
